module.exports = __webpack_public_path__ + "static/img/servicio3.9b43b19f.jpeg";